module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XaO81t/tc-custom/9781630473327.jpg?1696811664038",
      "alt": "This image is the cover for the book Focus on Impact"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Focus on Impact\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Never in the history of capitalism has there been a greater need for a shift in business focus. Consumers are cynical, skeptical and cautious, opening a new opportunity for difference-makers. We need to move away from the traditional money-driven business focus and focus all product design, marketing and delivery on making an immediate and lasting impact on people’s lives. This how-to manual provides proven strategies to build and grow any retail or service business that’s focused on impact with step-by-step, proven formulas to make it happen.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wendy Lipton-Dibner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("WENDY LIPTON-DIBNER, MA is a multiple-time bestselling author and internationally recognized authority in business acceleration through impact strategy. President of Professional Impact & founder of Professional Impact Academy and the Move People to Action System for Global Impact, Wendy is a world-class speaker, sought-after media guest and trusted advisor to doctors, executives, entrepreneurs & top influencers worldwide. She’s addressed the U.S. Senate & delivered thousands of programs on business growth for Fortune 100, healthcare, small business and non-profit organizations, touching millions of lives around the globe.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Moran James\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0